import { Testimonials } from 'models/Client'

export const hightlightCompanies: string[] = [
  'sevillaTechPark',
  'grupoTragsa',
  'keyterGroup',
  'ulma',
  'universidadDeMalaga',
  'AOPJA',
  'profand',
  'fagor',
  'naturgy',
]

export const ourClients: string[] = [
  'fagor',
  'naturgy',
  'ulma',
  'bbva',
  'airbus_h',
  'covap',
  'isdefe',
  'cosentino',
  'profand',
  'mahou',
  'verisure',
  'sacyr',
  'reale',
  'caf',
  'kutxabank',
  'renfe',
  'talgo_h',
  'navantia_h',
  'arteche',
  'tragsa',
  'ayesa',
  'oreka',
  'werfen',
  'esteve',
  'amb',
  'florette',
  'uva',
  'uja',
  'ugranada',
  'uab',
  // 'iberostar',
  // 'securitas',
  // 'norauto',
  // 'uma',
  // 'ule',
  // 'basf',
  // 'unavarra',
  // 'portBalears',
  // 'pct',
  // 'ccoo',
  // 'ajuntamentBarcelona',
  // 'amaya',
  // 'ajuntamentBenidorm',
  // 'navantia',
  // 'ule',
  // 'isdefe',
  // 'uva',
  // 'atexis',
  // 'mondragon',
]

export const testimonials: Testimonials = {
  testimonials: [
    {
      client: {
        name: 'Ibon Calvo',
        position: 'Presidente de la fundación y grupo ULMA',
        company: 'ULMA',
        avatar: 'ibon-calvo',
        companyLogo: 'ulma',
      },
      mesagge:
        'Ciclogreen nos aporta valor porque facilita los trayectos compartidos poniendo en contacto a personas trabajadoras con rutinas de viajes similares y los impulsa con un sistema de puntos y premios. Además, fomenta también otros medios de transporte sostenibles, por lo que se ha convertido en una medida clave dentro de nuestro Plan de Transporte al Trabajo. Comenzamos a utilizar la plataforma en 2017 y ya llevamos ahorrados más de 300 toneladas de emisiones de CO2.',
    },
    {
      client: {
        name: 'Pablo Olivares Phélix',
        position: 'Ingeniero de caminos del área de movilidad y sostenibilidad',
        company: 'AOPJA',
        avatar: 'pablo-olivares',
        companyLogo: 'aopja',
      },
      mesagge:
        'Lo más importante del Plan de Movilidad Sostenible ha sido como, gracias al apoyo de la aplicación de Ciclogreen, los compañeros de la Agencia de Obra Pública de la Junta de Andalucía han asumido la movilidad sostenible como algo positivo para ellos y para nuestro entorno social y medioambiental, más allá de los motivos iniciales de cada uno (retos y premios de Ciclogreen, ahorro de tiempo y coste, salud y bienestar, etc.), convirtiéndolo finalmente en un hábito. “Los temas de movilidad no son temas técnicos sino vitales.',
    },
    {
      client: {
        name: 'José Antonio Santoyo Román',
        position: 'Investigador de Smart-Campus',
        company: 'Universidad de Málaga',
        avatar: 'joseantoniosantoyo-uma',
        companyLogo: 'uma',
      },
      mesagge:
        'La implantación de Ciclogreen en la Universidad ha originado una mayor concienciación en la movilidad del Campus, además, la gamificación de la app ha generado que la Comunidad Universitaria se percate de que realmente es una parte importante en la lucha del cambio climático.',
    },
  ],
}

export const testimonialsCAEs: Testimonials = {
  testimonials: [
    {
      client: {
        name: 'Gustavo Risso',
        position: 'Responsable de Movilidad y Serv. del Parque Industrial',
        company: 'Cosentino',
        avatar: 'Gustavo-Risso',
        companyLogo: 'cosentino',
      },
      mesagge:
        'En Cosentino estamos comprometidos con la salud y el bienestar de nuestra gente, para juntos, conseguir una empresa más sostenible. Es por esto que decidimos implementar un nuevo sistema de coche compartido y una aplicación móvil para nuestros empleados, lo que les permitirá reducir su huella de carbono y ahorrar dinero en sus desplazamientos al trabajo. Con Ciclogreen hemos encontrado la solución que estábamos buscando. Además, hemos establecido un programa de incentivos y premios para fomentar la utilización del sistema compartido y estamos optimizando nuestros espacios de estacionamiento para priorizar los vehículos sostenibles. Creemos que pequeñas acciones como estas pueden tener un gran impacto en la lucha contra el cambio climático y estamos orgullosos de liderar el camino hacia un futuro más verde y sostenible.',
    },
    {
      client: {
        name: 'Pablo Olivares Phélix',
        position: 'Ingeniero de caminos del área de movilidad y sostenibilidad',
        company: 'AOPJA',
        avatar: 'pablo-olivares',
        companyLogo: 'aopja',
      },
      mesagge:
        'Lo más importante del Plan de Movilidad Sostenible ha sido como, gracias al apoyo de la aplicación de Ciclogreen, los compañeros de la Agencia de Obra Pública de la Junta de Andalucía han asumido la movilidad sostenible como algo positivo para ellos y para nuestro entorno social y medioambiental, más allá de los motivos iniciales de cada uno (retos y premios de Ciclogreen, ahorro de tiempo y coste, salud y bienestar, etc.), convirtiéndolo finalmente en un hábito. “Los temas de movilidad no son temas técnicos sino vitales.',
    },
    {
      client: {
        name: 'José Antonio Santoyo Román',
        position: 'Investigador de Smart-Campus',
        company: 'Universidad de Málaga',
        avatar: 'joseantoniosantoyo-uma',
        companyLogo: 'uma',
      },
      mesagge:
        'La implantación de Ciclogreen en la Universidad ha originado una mayor concienciación en la movilidad del Campus, además, la gamificación de la app ha generado que la Comunidad Universitaria se percate de que realmente es una parte importante en la lucha del cambio climático.',
    },
  ],
}

export const gridSustainability: any[] = [
  {
    img: 'monetize_grid',
    title: 'titleMonetize',
    text: 'textMonetize',
  },
  {
    img: 'compliance_grid',
    title: 'titleCompliance',
    text: 'textCompliance',
  },
  {
    img: 'reduce_costs_grid',
    title: 'titleReduceCosts',
    text: 'textReduceCosts',
  },
  {
    img: 'measure_results_grid',
    title: 'titleMeasureResults',
    text: 'textMeasureResults',
  },
]

export const odsColumns: string[] = ['11', '13']

export const solutionsMock: {
  img: string
  title: string
  text: string
  link?: string
}[] = [
  {
    img: 'design_plan',
    title: 'designPlan',
    text: 'designPlanText',
    link: 'https://plandemovilidadsostenible.com/',
  },
  {
    img: 'implementation',
    title: 'implementation',
    text: 'implementationText',
    link: 'https://ciclogreen.com/certificados-ahorro-energetico-carpooling-corporativo',
  },
  {
    img: 'tracking',
    title: 'tracking',
    text: 'trackingText',
    link: 'https://ciclogreen.com/calculator',
  },
]

export const hightlightPartners: string[] = [
  'horizon',
  'frontier',
  'fiware',
  'enisa',
  'eit',
  'edi',
]

export const benefitsMock: string[] = [
  'caesCo2',
  'caesMoney',
  'caesQuiet',
  'caesLaw',
]

export const benefitsMock2: string[] = [
  'accompaniment',
  'benefits',
  'accelerate',
  'opportunity',
]
